import { render, staticRenderFns } from "./IconImageComponent.vue?vue&type=template&id=63734a4e&"
import script from "./IconImageComponent.vue?vue&type=script&lang=js&"
export * from "./IconImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./IconImageComponent.vue?vue&type=style&index=0&id=63734a4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports